import { LogLevel } from 'configcat-react';
import { Environment } from '../common/types';

export interface ConfigState {
    featureToggles: {
        logLevel: LogLevel;
        cacheTimeToLiveSeconds: number;
    };
    id: string | undefined;
    login: LoginConfig;
    shouldMockAuthorization: boolean;
    mockLocale: string | undefined;
    webEdiServiceUrl: string | undefined;
    emailNotificationServiceUrl: string | undefined;
    locationDataServiceUrl: string | undefined;
    environmentFromUri: Environment | undefined;
    environmentConfig: EnvironmentSpecificConfig;
}

export interface LoginConfig {
    authority: string | undefined;
    clientId: string | undefined;
    oauthScope: string[];
    preventRedirect: boolean;
    redirectUri: string | undefined;
    silentRedirectUri: string | undefined;
    monitorSession?: boolean;
    mobilePhone?: string;
    postLogoutRedirectUri: string | undefined;
}

export interface EnvironmentSpecificConfig {
    closingDaysUrl: string;
    despatchUrl: string;
    executionLogUrl: string;
    htmlTitle: string;
    brand: 'rio' | 'vw';
    useVwTheme?: boolean;
}

export const asBool = (value: string | undefined): boolean => value === 'true';

const mapToConfigCatLogLevel = (logLevel: string | undefined): LogLevel => {
    switch (logLevel?.toUpperCase()) {
        case 'INFO':
            return LogLevel.Info;
        case 'WARN':
            return LogLevel.Warn;
        case 'ERROR':
            return LogLevel.Error;
        default:
            return LogLevel.Off;
    }
};

export const config: ConfigState = {
    featureToggles: {
        logLevel: mapToConfigCatLogLevel(import.meta.env.VITE_CONFIG_CAT_LOG_LEVEL),
        cacheTimeToLiveSeconds: 600,
    },
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_CLIENT_ID,
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
        oauthScope: ['openid', 'profile', 'email'],
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        postLogoutRedirectUri: import.meta.env.VITE_LOGOUT_URI,
    },
    shouldMockAuthorization: asBool(import.meta.env.VITE_LOGIN_MOCK_AUTHORIZATION),
    mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
    webEdiServiceUrl: import.meta.env.VITE_WEBEDI_SERVICE,
    emailNotificationServiceUrl: import.meta.env.VITE_EMAIL_NOTIFICATION_SERVICE,
    locationDataServiceUrl: import.meta.env.VITE_LOCATION_DATA_SERVICE,
    environmentFromUri: undefined,
    environmentConfig: {
        brand: 'rio',
        closingDaysUrl: import.meta.env.VITE_CLOSING_DAYS_FRONTEND_RIO,
        despatchUrl: import.meta.env.VITE_DESPATCH_FRONTEND_RIO,
        executionLogUrl: import.meta.env.VITE_EXECUTION_LOG_FRONTEND_RIO,
        htmlTitle: import.meta.env.VITE_VW_HTML_TITLE,
    },
};
